/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

import { CompareHero } from 'landing-pages/compare/sections/CompareHero/CompareHero';
import { CompareTable } from 'landing-pages/compare/sections/CompareTable/CompareTable';
import { CompareStats } from 'landing-pages/compare/sections/CompareStats/CompareStats';
import { CompareNarrative } from 'landing-pages/compare/sections/CompareNarrative/CompareNarrative';
import { CompareFeatures } from 'landing-pages/compare/sections/CompareFeatures/CompareFeatures';

import styles from './ComparePage.module.scss';

import type { CompareData } from './Compare.types';

export const ComparePage = ({ data }: { data: CompareData }) => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <CompareHero data={data} />

      <CompareTable
        id="comparison"
        title={data.table.title}
        description={data.table.description}
        rows={data.table.rows}
        competitorHeader={data.competitorHeader}
        competitorLogo={data.competitorLogo}
      />

      <CompareStats id="provenance" data={data.stats} background="#f6f7f9" />

      <CompareNarrative
        id="difference"
        title={data.difference.title}
        description={data.difference.description}
        paragraphs={data.difference.paragraphs}
        pull={data.difference.pull}
      />

      <CompareFeatures
        id="features"
        title={data.features.title}
        description={data.features.description}
        gd={data.features.gd}
        them={data.features.them}
        competitorHeader={data.competitorHeader}
        competitorLogo={data.competitorLogo}
        background="#f6f7f9"
      />

      {data.extra && (
        <CompareNarrative
          id={data.extra.id ?? 'extra'}
          title={data.extra.title}
          description={data.extra.description}
          paragraphs={data.extra.paragraphs}
          pull={data.extra.pull}
        />
      )}

      <CtaSection
        spotlight
        theme="dark"
        title={data.cta.title}
        description={data.cta.description}
        actions={
          <>
            <Button type="blue" size="xl" href="/book-a-demo">
              {t('Request a data review')}
            </Button>

            <Button type="white-outline" size="xl" href="/book-a-demo">
              {t('Book a demo')}
            </Button>
          </>
        }
      />

      <Faq className={styles.faq} title={data.faq.title} data={data.faq.data} />
    </div>
  );
};
